import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isUserInspectorSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';
import moment from 'moment';


const mapFilterData = (data: IUserInspectorSearchForm): IUserInspectorSearchPost | {} => {
  let processedData: IUserInspectorSearchForm;
  processedData = {
    datetimeFrom: data.datetimeFrom ? `${moment(data.datetimeFrom).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : "",
    datetimeTo: data.datetimeTo ? `${moment(data.datetimeTo).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : "",
    username: data.username
  }
  
  if (isUserInspectorSearchFormEmpty(processedData) || processedData == undefined) { return {} };
  const removedUnusedFilters = filterNonEmptyValues(processedData);
  //applDate: values.applDate ? `${moment(values.applDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null ,

  return removedUnusedFilters;
}

const getAllUserInspectorData = async ( {data} : {data: IUserInspectorSearchForm}): Promise<IGetUserInspectorData> => {
  const filterData = mapFilterData(data);
  const response =  await axiosDefaultApi.post(`/api/Search/Search/SysEventsInspector?pageNumber=1&pageSize=500000`, filterData);
  return response as unknown as IGetUserInspectorData;
};

type QueryFnType = typeof getAllUserInspectorData;

type UseGetAllUserInspectorDataOptions = {
  data: IUserInspectorSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllUserInspectorData = ({ data, config }: UseGetAllUserInspectorDataOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllUserInspectorData'],
    queryFn: () => getAllUserInspectorData({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των κινήσεων.`, 500);
      setIsNotificationVisible(true);
      console.log(error);
    }
  });
};